import React from 'react';
import './ClientLogos.css';

function ClientLogos() {
  const logos = [
    {
      src: '/img/reference_1.jpg',
      alt: 'Client Reference 1',
      width: 170,
      invert: false
    },
    {
      src: '/img/sarah_logo.png',
      alt: 'Sarah Rickmers',
      width: 180,
      invert: true
    },
    {
      src: '/img/reference_2.jpg',
      alt: 'Client Reference 2',
      width: 190,
      invert: false
    },
    {
      src: '/img/reference_3.jpg',
      alt: 'Client Reference 3',
      width: 180,
      invert: false
    },
    {
      src: '/img/michaela_logo.png',
      alt: 'Michaela Braun',
      width: 170,
      invert: true
    },
    {
      src: '/img/reference_4.jpg',
      alt: 'Client Reference 4',
      width: 200,
      invert: false
    },
    {
      src: '/img/caro_logo.png',
      alt: 'Carolin Kendermann',
      width: 160,
      invert: true
    },
    {
      src: '/img/reference_5.jpg',
      alt: 'Client Reference 5',
      width: 170,
      invert: false
    },
    {
      src: '/img/reference_6.jpg',
      alt: 'Client Reference 6',
      width: 190,
      invert: false
    },
    {
      src: '/img/martin_logo.png',
      alt: 'Weinhaus Schowalter',
      width: 150,
      invert: true
    },
    {
      src: '/img/reference_7.jpg',
      alt: 'Client Reference 7',
      width: 180,
      invert: false
    },
    {
      src: '/img/sebastian_logo.webp',
      alt: 'Sebastian Laible',
      width: 140,
      invert: true
    },
    {
      src: '/img/reference_8.jpg',
      alt: 'Client Reference 8',
      width: 195,
      invert: false
    },
    {
      src: '/img/reference_9.jpg',
      alt: 'Client Reference 9',
      width: 185,
      invert: false
    },
    {
      src: '/img/reference_10.jpg',
      alt: 'Client Reference 10',
      width: 175,
      invert: false
    }
  ];

  return (
    <section className="client-logos-section" id="kunden">
      <div className="client-logos-container">
        <div className="client-logos-header">
        </div>

        <div className="client-logos-grid">
          {logos.map((logo, index) => (
            <div 
              key={index} 
              className="client-logo-item"
              style={{ '--logo-width': `${logo.width}px` }}
            >
              <img 
                src={logo.src} 
                alt={logo.alt}
                className={logo.invert ? 'invert-logo' : ''}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default ClientLogos;

